import { DamagedItemStatus, MultiOrderSegment, Order, OrderItemStatus } from '../views/Orders/order.types';

export const getOverallStatus = (orders: MultiOrderSegment[]): OrderItemStatus | null => {
  if (!orders || orders.length === 0) return null;

  const statusPriority = {
    [OrderItemStatus.READY_FOR_PICK_UP]: 1,
    [OrderItemStatus.DAMAGED_READY_FOR_PICK_UP]: 1,
    [OrderItemStatus.PREPARING]: 2,
    [OrderItemStatus.DAMAGED_PREPARING]: 2,
    [OrderItemStatus.DELIVERING]: 3,
    [OrderItemStatus.DAMAGED_DELIVERING]: 3,
    [OrderItemStatus.DELIVERED]: 4,
    [DamagedItemStatus.CANCELLED]: 5,
    [DamagedItemStatus.DAMAGED_CANCELLED]: 5,
  };

  let highestPriorityStatus: OrderItemStatus | null = null;
  let highestPriority = 999;

  orders.forEach((order) => {
    const priority = statusPriority[order.status as OrderItemStatus];
    if (priority !== undefined && priority < highestPriority) {
      highestPriority = priority;
      highestPriorityStatus = order.status as OrderItemStatus;
    }
  });

  return highestPriorityStatus;
};

export const multiOrderIndicator = (row: Order) => {
  if (!row.multi_orders?.length) return '-';
  return `${row.multi_orders.length}`;
};

export const isAllMatch = (multi_orders: MultiOrderSegment[], status: OrderItemStatus): boolean => {
  const statusPriority = {
    [OrderItemStatus.PREPARING]: 1,
    [OrderItemStatus.DAMAGED_PREPARING]: 1,
    [OrderItemStatus.READY_FOR_PICK_UP]: 2,
    [OrderItemStatus.DAMAGED_READY_FOR_PICK_UP]: 2,
    [OrderItemStatus.DELIVERING]: 3,
    [OrderItemStatus.DAMAGED_DELIVERING]: 3,
    [OrderItemStatus.DELIVERED]: 4,
  };

  const allStatusesSatisfied = multi_orders?.every((item: MultiOrderSegment) => {
    const priority = statusPriority[item.status as OrderItemStatus];
    return priority && priority >= statusPriority[status];
  });

  if (allStatusesSatisfied) {
    return true;
  }

  return false;
};

export const formatSeatInfo = (information: any) => {
  if (!information) return '';
  const { block, seat_type, area, row, seat_number } = information;
  return [area, seat_type, block, row, seat_number].filter(Boolean).join('・');
};
